module.exports = __webpack_public_path__ + "assets/images/scene-4_5405195857ef7217a47da440164f2280.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-one/croma-abeldo-dialogs/scene-4.png
// module id = 203
// module chunks = 0